import { useRouter } from "next/router";
import * as F from "./FilterList.styles";
import { Fragment, useEffect } from "react";
import SizeFilter from "../ecommerce/Filter/SizeFilter";

const Filter = (props) => {
  const { handleQuery, filters, queries, handleSizeFilter } = props;
  const router = useRouter();

  return (
    <>
      {Object.keys(filters)?.length > 0 && (
        <F.FilterWrapper>
          {Object.keys(filters).map((filter, i) => (
            <Fragment key={i}>
              {filters[filter].values?.length > 0 && (
                <F.FilterRow>
                  <F.FilterRowTitle>{filters[filter].name}</F.FilterRowTitle>
                  <F.FilterRowList>
                    {filters[filter].values.map((row, rowIdx) => (
                      <li key={rowIdx}>
                        <a
                          onClick={() =>
                            handleQuery(filters[filter].type, row.value)
                          }
                          className={`${
                            queries[filters[filter].type] &&
                            queries[filters[filter].type].includes(row.value) &&
                            "active"
                          }`}
                        >
                          {row.name}
                          {queries[filters[filter].type] &&
                            queries[filters[filter].type].includes(
                              row.value
                            ) && (
                              <span>
                                <i className="fi-rs-cross" />
                              </span>
                            )}
                        </a>
                      </li>
                    ))}
                  </F.FilterRowList>
                </F.FilterRow>
              )}
            </Fragment>
          ))}
          <F.FilterRow>
            <F.FilterRowTitle>사이즈</F.FilterRowTitle>
            <F.FilterRowList>
              <div className="d-flex p-10">
                <SizeFilter
                  handleSizeFilter={handleSizeFilter}
                  selectedCategory={queries.category_code}
                />
              </div>
            </F.FilterRowList>
          </F.FilterRow>
          {queries &&
            Object.values(queries).filter((el) => el != "").length > 0 && (
              <F.FilteredListWrapper>
                <div className="all">
                  <a
                    onClick={() => {
                      sessionStorage.setItem(
                        `__next_scroll_${router.pathname}`,
                        JSON.stringify({
                          x: window.scrollX,
                          y: window.scrollY,
                        })
                      );
                      router.push("", {
                        query: {},
                      });
                    }}
                  >
                    전체 해제 <i className="fi-rs-rotate-left" />{" "}
                  </a>
                </div>
                <F.CheckedFilters>
                  {Object.keys(queries)?.length > 0 &&
                    Object.keys(queries).map((query) => {
                      if (query !== "sizes") {
                        return filters[query]?.values.map((value, vIdx) => {
                          if (queries[query].split(" ").includes(value.value)) {
                            return (
                              <li
                                key={vIdx}
                                onClick={() => handleQuery(query, value.value)}
                              >
                                <a>{value.name}</a>
                              </li>
                            );
                          } else {
                            return "";
                          }
                        });
                      } else {
                        return (
                          <li onClick={() => handleQuery(query, "")}>
                            <a>사이즈 필터</a>
                          </li>
                        );
                      }
                    })}
                </F.CheckedFilters>
              </F.FilteredListWrapper>
            )}
        </F.FilterWrapper>
      )}
    </>
  );
};
export default Filter;
